import { ref } from 'vue'

// 极简提示条，替代 element-plus 的 ElMessage（整个 UI 库 1MB+，只用到这一个功能）
export const toasts = ref([])
let seq = 0

export function toast(message, type = 'info', duration = 4000) {
  const id = ++seq
  toasts.value.push({ id, message, type })
  setTimeout(() => {
    toasts.value = toasts.value.filter(t => t.id !== id)
  }, duration)
}
